import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { useEffect, useState, useRef } from "react";

export const MultipleSelectRadioButtonTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const options = uischema?.options?.additionalData || [];
  const ctx = useJsonForms();
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);

  const handleClick = (item: any) => {
    const func = (prevValue: any[]) => {
      // Ensure `prevValue` is an array
      const updatedValue =
        Array.isArray(prevValue) && prevValue.length > 0 ? prevValue : [];

      if (Array.isArray(prevValue)) {
        // Check if the item already exists in the array
        const itemExists = updatedValue.some(
          (existingItem) => existingItem.value === item.value
        );

        // Add the item if it doesn't exist, or remove it if it does (toggle behavior)
        if (itemExists) {
          return updatedValue.filter(
            (existingItem) => existingItem.value !== item.value
          );
        } else {
          updatedValue.push(item);
          return updatedValue;
        }
      } else {
        updatedValue.push(item);

        return updatedValue;
      }
    };

    const newValue = func(data);
    console.log("data", newValue);
    handleChange(path, newValue);
  };
  const width = uischema?.options?.buttonWidth;
  const show = uischema?.options?.show;
  const titleClassName = uischema?.options?.titleClassName;
  useEffect(() => {
    if (show == false) {
      handleChange(path, {});
    }
  }, [show]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return show === undefined || show === true ? (
    <div ref={positionRef} className="mt-8">
      <p
        className={`${
          titleClassName
            ? titleClassName
            : "font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-4 text-brand-bgBlack uppercase"
        }`}
      >
        {schema?.title}
      </p>
      <div className="flex flex-wrap gap-7 mt-5">
        {options.map((item: any) => (
          <Button
            className={`text-brand-bgBlack relative rounded-full border hover:bg-brand-lightOrange px-9 ${
              width ? width : "w-fit"
            }  ${
              data?.some((dataItem: any) => dataItem?.value === item?.value)
                ? "bg-brand-lightOrange"
                : "bg-white"
            }`}
            key={item?.value}
            onClick={() => handleClick(item)}
          >
            {item?.title}
          </Button>
        ))}
      </div>{" "}
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  ) : (
    <></>
  );
};

export default withJsonFormsControlProps(MultipleSelectRadioButtonTypeRenderer);
